import { __decorate, __metadata } from "tslib";
import { IsBoolean, IsOptional } from 'class-validator';
/**
 * The request to generate a User's MFA Recovery Codes
 */
export class GenerateRecoveryCodesBody {
    /**
     * @param regenerate Indicates whether the exiting recovery codes (if any) should be replaced.
     */
    constructor(regenerate) {
        this.regenerate = regenerate;
    }
}
__decorate([
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], GenerateRecoveryCodesBody.prototype, "regenerate", void 0);
